import { Component, OnInit, forwardRef, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { 
    
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { environment } from '@app/environment';
import { DataService } from '@app/services';
import { Challenge, ResponseChallengeStatus } from '@app/models';

@Component({
    selector: 'app-challenge-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        TranslatePipe
    ]
})
export class ChallengesItemComponent  implements OnInit {
      
    @Input({alias : 'challenge', required : true}) challenge: Challenge;
    @Input({alias : 'isClickable', required : false}) isClickable: boolean = true;
    @Output() onClickChallenge = new EventEmitter<Challenge>();
    
    responseChallengeStatus: ResponseChallengeStatus = new ResponseChallengeStatus();
    description: string;
    levelLabel: string = '';
    incentivePointsLabel: SafeHtml;
    incentiveLabel: SafeHtml;
    dateChallenge: string = '';
    lostIncentives: boolean = false;
    
    constructor(     
        private domSanitizer: DomSanitizer,
        public translateService: TranslateService,
        public dataService: DataService
    ) { }

    ngOnInit() {
        
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['challenge'] && changes['challenge'].currentValue){
            this.initChallenge();
        }
    }
    
    initChallenge(){
        
        this.isClickable = true;
        let description: string = '';
        if(this.challenge.category === 'history' && ['demonstration','sale'].indexOf(this.challenge.type) !== -1){
            if(this.challenge.type === 'demonstration'){
                description = this.translateService.instant('CHALLENGE.DEMONSTRATION_TITLE');
            }
            else{
                description = this.translateService.instant('CHALLENGE.SALE_TITLE');
            }
            let match = this.dataService.ambassador.matches.find(m => m.ID === this.challenge.response?.matchID);
            if(match){
                description += ' : '+match.tester?.firstName+' '+match.tester?.lastName;
            }      
            else {
                description = this.translateService.instant('CHALLENGE.MANUALLY_VALIDATED');
                this.isClickable = false;
            }     
        }
        else{
            let tmp = document.createElement("div");
            tmp.innerHTML = (this.challenge.description && this.challenge.description !== '' ? this.translateService.instant(this.challenge.description) : '');
            description = tmp.innerText;
        }
        this.description = description;
        
        let levelLabel = '';
        if(this.challenge.level === 'missions'){
            levelLabel = this.translateService.instant('CHALLENGE.LEVEL_MISSION');
        }
        else if (this.challenge.level === 'flash'){
            levelLabel = this.translateService.instant('CHALLENGE.LEVEL_FLASH');
        }
        else if(!isNaN(parseInt(this.challenge.level))){
            let level = this.dataService.operation.levels[this.challenge.level];
            levelLabel = (level ? level.name : '');
        }
        this.levelLabel = levelLabel;
        
        let nbPointsLabel = '';        
        let incentiveLabel = '';
        if(this.challenge.response?.status === environment.CHALLENGE_VALIDATION_TYPE.VALIDATED){
            if(this.challenge.response.points > 0){
                nbPointsLabel = this.translateService.instant('CHALLENGE.POINTS_EARNED').replace('{nb_points}', this.challenge.response.points);
                if(this.challenge.response.incentive){
                    incentiveLabel = '+<b>'+this.challenge.response.incentive+'</b> '+this.challenge.response.devise;
                }
            }
        }
        else{
            if(this.challenge.points > 0){
                nbPointsLabel = this.translateService.instant('CHALLENGE.POINTS_TO_WIN').replace('{nb_points}', this.challenge.points);
                if(this.challenge.incentive){   
                    incentiveLabel = '+<b>'+this.challenge.incentive+'</b> '+this.challenge.devise;
                }
            }
        }
        this.incentivePointsLabel = (nbPointsLabel !== '' ? this.domSanitizer.bypassSecurityTrustHtml(nbPointsLabel) : '');
        this.incentiveLabel = (incentiveLabel !== '' ? this.domSanitizer.bypassSecurityTrustHtml(incentiveLabel) : '');
        
        this.lostIncentives = (this.challenge.category === 'history' && [environment.CHALLENGE_VALIDATION_TYPE.DENIED, environment.CHALLENGE_VALIDATION_TYPE.DENIED_DEFINITELY].indexOf(this.challenge.response?.status) !== -1);
        
        this.responseChallengeStatus = ResponseChallengeStatus.FromStatus(this.challenge.response?.status, this.challenge.type);
        
        if(this.challenge.response?.date){            
            this.dateChallenge = this.translateService.instant('CHALLENGE.DATE_RESPONSE').replace('{date_response}', moment(this.challenge.response.date).format('DD/MM/YYYY'));
        }
    }
    
    selectChallenge() {        
        if(this.isClickable){        
            this.onClickChallenge.emit(this.challenge);
        }
    }
}
